<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll>
          <v-toolbar-title class="font-weight-black primary--text"
            >Reporte de Vacaciones</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarOcultarPersonas"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ mostrarInactivos ? "visibility_off" : "visibility" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              mostrarInactivos ? "Ocultar Inactivos" : "Mostrar Inactivos"
            }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="sincronizarPersona"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> fa-solid fa-arrows-rotate </v-icon>
              </v-btn>
            </template>
            <span>Sincronizar Personas</span>
          </v-tooltip>

          <v-menu :rounded="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon large color="primary" v-bind="attrs" v-on="on" dark>
                <v-icon dark>fa-solid fa-money-bill-1-wave</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="mostrarPersonaIncremento">
                <v-list-item-title
                  >Modificación masiva de Sueldos</v-list-item-title
                >
              </v-list-item>
              <v-list-item @click="dialogSincronizarSueldos = true">
                <v-list-item-title
                  >Sincronizar Sueldos con Novus</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="exportarExcel"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> fa-solid fa-file-excel </v-icon>
              </v-btn>
            </template>
            <span>Exportar a Excel</span>
          </v-tooltip>

          <v-menu :rounded="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon large color="primary" v-bind="attrs" v-on="on" dark>
                <v-icon dark>fa-solid fa-cloud-arrow-up </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="mostrarCarga('variacion')">
                <v-list-item-title
                  >Carga para Análisis de Variación</v-list-item-title
                >
              </v-list-item>
              <v-list-item @click="mostrarCarga('persona')">
                <v-list-item-title>Carga Masiva de Personas</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="addItem"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> add </v-icon>
              </v-btn>
            </template>
            <span>Ingresar nuevo registro</span>
          </v-tooltip>
        </v-app-bar>
        <v-sheet
          class="overflow-y-auto"
          :max-height="windowHeigth + this.auxHeigth"
        >
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - 265 + auxHeigth"
            :headers="headersPersona"
            @click.native.ctrl="clickEvent"
            @click:row.ctrl="rowCtrlClicked"
            @click:row="rowClick"
            :items="personas"
            sort-by="codigo"
            class="elevation-1"
            :search="searchPersonaValue"
            show-group-by
            :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Filas por página',
              'items-per-page-options': [30, 50, 100, 200, -1],
            }"
          >
            <template v-slot:[`item.dias_vacacion`]="{ item }">
              <v-btn text class="primary--text" @click="editItemPersona(item)">
                {{ $formatoNumero(item.dias_vacacion) }}
              </v-btn>
            </template>
            <template v-slot:[`item.codigo`]="{ item }">
              <img
                v-if="
                  !(
                    item.foto === null ||
                    item.foto === undefined ||
                    item.foto === ''
                  )
                "
                v-img
                :src="item.foto"
                style="
                   {
                    object-fit: fill;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    border: solid 1px #ccc;
                  }
                "
              />
              <v-btn text class="primary--text" @click="editItemPersona(item)">
                {{ item.codigo }}
              </v-btn>
            </template>

            <template v-slot:[`item.estado`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="item.estado == 'A' ? 'success' : 'error'"
                    small
                    fab
                    text
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="activarDialog(item)"
                  >
                    <v-icon small>
                      {{
                        item.estado == "A"
                          ? "fa-solid fa-circle-check"
                          : "fa-solid fa-circle-xmark"
                      }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{
                  item.estado == "A" ? "Desactivar Persona" : "Activar Persona"
                }}</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.area`]="{ item }">
              <div class="font-weight-bold text--primary">
                <v-badge
                  :value="!item.id_cupo"
                  color="error"
                  icon="fa-solid fa-exclamation"
                  inline
                  left
                >
                  {{ item.cargo }}
                </v-badge>
              </div>

              <div class="font-weight-bold button text--secondary">
                {{ item.subarea }}
              </div>
              <div class="font-weight-medium caption text--disabled">
                {{ item.area }}
              </div>
            </template>

            <template v-slot:[`item.nombre_completo`]="{ item }">
              <div>
                {{ item.nombre_completo }}
              </div>

              <div class="font-weight-medium caption text--disabled">
                {{ item.profesion }}
              </div>
            </template>

            <template v-slot:[`item.fecha_ingreso`]="{ item }">
              <v-list-item-subtitle class="font-weight-bold text--primary">
                Ingreso: {{ $formatoFechaSpanish(item.fecha_ingreso) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                class="font-weight-bold button text--secondary"
                v-if="!$esNulo(item.fecha_salida)"
              >
                Salida: {{ $formatoFechaSpanish(item.fecha_salida) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="font-weight-medium caption"
                >Nacimiento:
                {{ $formatoFechaSpanish(item.fecha_nac) }}</v-list-item-subtitle
              >
            </template>

            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-spacer></v-spacer>

                <v-text-field
                  outlined
                  dense
                  class="text-xs-center"
                  v-model="searchAreaValue"
                  append-icon="search"
                  label="Area"
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  outlined
                  dense
                  class="text-xs-center"
                  v-model="searchCargoValue"
                  append-icon="search"
                  label="Cargo"
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  outlined
                  dense
                  class="text-xs-center"
                  v-model="searchPersonaValue"
                  append-icon="search"
                  label="Persona"
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template v-slot:no-data> No se encontraron registros </template>
          </v-data-table>
        </v-sheet>
      </v-card>

      <v-dialog
        v-model="dialogPersona"
        persistent
        max-width="700px"
        transition="dialog-bottom-transition"
      >
        <v-card ref="formPersona" class="overflow-hidden">
          <v-app-bar color="white" elevate-on-scroll>
            <v-toolbar-title class="primary--text">
              <img
                v-if="!(foto === null || foto === undefined || foto === '')"
                v-img
                :src="foto"
                style="
                   {
                    object-fit: fill;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    border: solid 1px #ccc;
                  }
                "
              />
              <strong>{{ formTitle }}</strong></v-toolbar-title
            >
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  color="primary"
                  @click="closePersona"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Volver/Cancelar</span>
            </v-tooltip>
          </v-app-bar>
          <v-app-bar color="white" elevate-on-scroll>
            <v-dialog
              v-model="modalFechaIni"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  readonly
                  outlined
                  locale="es"
                  type="month"
                  dense
                  ref="fecha_inicio"
                  v-model="fecha_inicio"
                  :rules="[$rules.requerido]"
                  @change="listarPersona"
                  @click="modalFechaIni = true"
                  :error-messages="errorMessagesPersona"
                  label="Periodo inicial"
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                locale="es"
                v-model="fecha_inicio"
                type="month"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalFechaIni = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="setFechaIni(date)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>

            <v-spacer></v-spacer>
            <v-dialog
              v-model="modalFechaFin"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  readonly
                  outlined
                  type="month"
                  dense
                  ref="fecha_fin"
                  v-model="fecha_fin"
                  :rules="[$rules.requerido]"
                  @change="listarPersona"
                  @click="modalFechaFin = true"
                  :error-messages="errorMessagesPersona"
                  label="Periodo Final"
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="fecha_fin" type="month" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalFechaFin = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="setFechaFin(date)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-app-bar>

          <v-sheet
            class="overflow-y-auto"
            :max-height="windowHeigth + this.auxHeigth"
          >
            <v-data-table
              dense
              fixed-header
              :height="windowHeigth - 300 + auxHeigth"
              :headers="headersVacacion"
              @click.native.ctrl="clickEvent"
              @click:row.ctrl="rowCtrlClicked"
              @click:row="rowClick"
              :items="personasVacacion"
              sort-by="codigo"
              class="elevation-1"
              :search="searchPersonaValue"
              show-group-by
              :header-props="{
                'sort-icon': 'fa-solid fa-arrow-down-wide-short',
              }"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-text': 'Filas por página',
                'items-per-page-options': [-1],
              }"
            >
              <template v-slot:[`item.ganada`]="{ item }">
                {{
                  $formatoNumero(item.ganada)
                }}
              </template>

              <template v-slot:[`item.tomada`]="{ item }">
                {{
                  $formatoNumero(item.tomada)
                }}
              </template>

              <template v-slot:[`item.saldo`]="{ item }">
                {{
                  $formatoNumero(item.saldo)
                }}
              </template>

              

              <template slot="body.append">
                <td colspan="2" align="right" class="font-weight-bold">
                  Totales
                </td>

                <td align="center" class="font-weight-bold">
                  {{ vacacionTomadaTotal.ganada }}
                </td>
                <td align="center" class="font-weight-bold">
                  {{ vacacionTomadaTotal.tomada }}
                </td>
                <td align="center" class="font-weight-bold">
                  {{ vacacionTomadaTotal.saldo }}
                </td>
                
              </template>
              <template slot="body.prepend">
                <td colspan="2" align="right" class="font-weight-bold">
                  Totales
                </td>

                <td align="center" class="font-weight-bold">
                  {{ vacacionTomadaTotal.ganada }}
                </td>
                <td align="center" class="font-weight-bold">
                  {{ vacacionTomadaTotal.tomada }}
                </td>
                <td align="center" class="font-weight-bold">
                  {{ vacacionTomadaTotal.saldo }}
                </td>
                
              </template>

              <template v-slot:no-data> No se encontraron registros </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogActivar" persistent max-width="290">
        <v-card>
          <div v-if="estado == 'A'">
            <v-card-title class="headline">Desactivar Persona</v-card-title>
            <v-card-text
              >Esta acción desactivará la Persona seleccionada ¿Desea
              continuar?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogActivar = false">Cancelar</v-btn>
              <v-btn color="primary" text @click="desactivar()"
                >Continuar</v-btn
              >
            </v-card-actions>
          </div>
          <div v-else>
            <v-card-title class="headline">Activar Persona</v-card-title>
            <v-card-text
              >Esta acción activará la Persona seleccionada. ¿Desea
              continuar?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogActivar = false">Cancelar</v-btn>
              <v-btn color="primary" text @click="activar()">Continuar</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSincronizarSueldos" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción revertirá todos los cambios que realizó en los salarios
            del módulo. ¿Desea continuar?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogSincronizarSueldos = false"
              >Cancelar</v-btn
            >
            <v-btn color="primary" text @click="sincronizarSalarios()"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogNit" max-width="500px">
        <v-card ref="form">
          <v-card-title>
            <span class="headline">Agregar Nit</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    ref="codigoNit"
                    v-model="codigoNit"
                    :rules="[$rules.requerido, $rules.min2, $rules.max25]"
                    :error-messages="errorMessagesNit"
                    label="Nit"
                    placeholder="Nit"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    ref="descripcionNit"
                    v-model="descripcionNit"
                    :rules="[$rules.requerido, $rules.min2, $rules.max100]"
                    :error-messages="errorMessagesNit"
                    label="Razón Social"
                    placeholder="Razón Social"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="notasNit"
                    v-model="notasNit"
                    :rules="[]"
                    :error-messages="errorMessagesNit"
                    label="Notas"
                    placeholder="Notas"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    ref="primer_nombreNit"
                    v-model="primer_nombreNit"
                    :rules="[]"
                    :error-messages="errorMessagesNit"
                    label="Primer Nombre"
                    placeholder="Primer Nombre"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    ref="segundo_nombreNit"
                    v-model="segundo_nombreNit"
                    :rules="[]"
                    :error-messages="errorMessagesNit"
                    label="Segundo Nombre"
                    placeholder="Segundo Nombre"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    ref="primer_apellidoNit"
                    v-model="primer_apellidoNit"
                    :rules="[]"
                    :error-messages="errorMessagesNit"
                    label="Primer Apellido"
                    placeholder="Primer Apellido"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    ref="segundo_apellidoNit"
                    v-model="segundo_apellidoNit"
                    :rules="[]"
                    :error-messages="errorMessagesNit"
                    label="Segundo Apellido"
                    placeholder="Segundo Apellido"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    ref="direccionNit"
                    v-model="direccionNit"
                    :rules="[]"
                    :error-messages="errorMessagesNit"
                    label="Dirección"
                    placeholder="Dirección"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    ref="correoNit"
                    v-model="correoNit"
                    :rules="[]"
                    :error-messages="errorMessagesNit"
                    label="Correo"
                    placeholder="Correo"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    ref="telefonoNit"
                    v-model="telefonoNit"
                    :rules="[]"
                    :error-messages="errorMessagesNit"
                    label="Teléfono"
                    placeholder="Teléfono"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    ref="celularNit"
                    v-model="celularNit"
                    :rules="[]"
                    :error-messages="errorMessagesNit"
                    label="Celular"
                    placeholder="Celular"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeNit">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarNit">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { json2excel, excel2json } from "js2excel";

export default {
  data() {
    return {
      auxWidth: 0,
      auxHeigth: 0,
      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight + this.auxHeigth,
      camera: "auto",
      result: null,
      showScanConfirmation: false,
      mostrarBusquedas: false,
      personas: [],
      personasVacacion: [],

      cargos: [],
      cupos: [],
      grupos: [],

      areas: [],
      subareas: [],
      parentescos: [],
      paises: [],
      ciudades: [],
      ciudadesDir: [],
      bancos: [],
      seguros: [],
      LineaVentas: [],
      lineaVentasList: [],
      personasIncremento: [],
      personasIncrementoSelect: [],
      selectPersonasIncremento: [],
      nits: [],
      usuario: this.$store.state.usuario.user,

      tipoDocumento: [
        { id: "CI", descripcion: "Carnet de Identidad" },
        { id: "CE", descripcion: "Carnet de Extranjero" },
        { id: "PA", descripcion: "Pasaporte" },
        { id: "SC", descripcion: "Otro" },
      ],
      cant_subsidios: [0, 1, 2, 3],

      fondoPension: [{ id: "GES", descripcion: "GESTORA" }],
      nivelesAcademicos: [
        { id: "Universitario", descripcion: "Universitario" },
        { id: "Secundaria", descripcion: "Secundaria" },
        { id: "Master", descripcion: "Master" },
        { id: "Posgrado", descripcion: "Posgrado" },
        { id: "Terciario", descripcion: "Terciario" },
      ],
      subsidios: [
        { id: "S", descripcion: "SI" },
        { id: "N", descripcion: "NO" },
      ],
      tipoSangre: [
        "O NEGATIVO",
        "O POSITIVO",
        "A NEGATIVO",
        "A POSITIVO",
        "B NEGATIVO",
        "B POSITIVO",
        "AB NEGATIVO",
        "AB POSITIVO",
        "NO DETERMINADO",
      ],

      lugarEmision: [
        { id: "SC", descripcion: "Santa Cruz" },
        { id: "LP", descripcion: "La Paz" },
        { id: "CB", descripcion: "Cochabamba" },
        { id: "BE", descripcion: "Beni" },
        { id: "CH", descripcion: "Chuquisaca" },
        { id: "OR", descripcion: "Oruro" },
        { id: "PN", descripcion: "Pando" },
        { id: "PT", descripcion: "Potosí" },
        { id: "TJ", descripcion: "Tarija" },
        { id: "O", descripcion: "Otro" },
      ],

      formaPagos: ["Banco", "Efectivo", "Cheque"],

      generos: ["Masculino", "Femenino", "Otro"],
      estadoCiviles: ["Soltero", "Casado", "Otro"],
      actividadEconomicas: [
        "AGRICULTURA, PECUARIO, SILVICULTURA, CAZA Y PESCA",
        "PETRÓLEO CRUDO Y GAS NATURAL",
        "MINERALES METÁLICOS Y NO METÁLICOS",
        "INDUSTRIA DE ALIMENTOS",
        "OTRAS INDUSTRIAS",
        "ELECTRICIDAD, GAS Y AGUA",
        "CONSTRUCCIÓN",
        "COMERCIO",
        "TRANSPORTE Y ALMACENAMIENTO",
        "COMUNICACIONES",
        "SERVICIOS FINANCIEROS",
        "SERVICIOS A LAS EMPRESAS",
        "PROPIEDAD DE VIVIENDA",
        "SERVICIOS DE LA ADMINISTRACIÓN PÚBLICA",
        "IMPORTACIONES",
        "OTROS SERVICIOS",
      ],

      dialogPersona: false,
      dialogSincronizarSueldos: false,
      dialogBorrarLineaVenta: false,
      dialogFoto: false,
      dialogUpload: false,
      dialogPorcentaje: false,
      dialogPersonaIncremento: false,
      dialogNit: false,
      mostrarMensaje: false,

      //
      page: 1,
      itemsPerPage: 12,
      headersPersona: [
        {
          text: "Código",
          value: "codigo",
          groupable: false,
          align: "right",
          class: "primary white--text text-subtitle-2",
        },

        {
          text: "Nombre",
          value: "nombre_completo",
          filter: this.filtroNombre,
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cargo",
          value: "area",
          filter: this.filtroArea,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cargo",
          value: "cargo",
          filter: this.filtroCargo,
          class: "primary white--text text-subtitle-2",
          align: " d-none",
        },
        {
          text: "Saldo Vacación",
          value: "dias_vacacion",
          align: "center",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Equipo",
          value: "equipo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Sucursal",
          value: "ciudad",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cenco",
          value: "centro_costo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Grupo Nómina",
          value: "grupo_nomina",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Fechas",
          value: "fecha_ingreso",
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersVacacion: [
        {
          text: "Año",
          value: "anio",
          align: "center",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Mes",
          value: "mes",
          align: "center",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Vacación ganada",
          value: "ganada",
          align: "center",
          groupable: false,
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Vacación tomada",
          value: "tomada",
          groupable: false,
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Saldo Vacación",
          value: "saldo",
          groupable: false,
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
      ],

      rules: {
        requerido: (value) => !!value || "Debe llenar este campo.",
        numero: (value) => {
          const pattern = /^\d*\.?\d*$/;
          return pattern.test(value) || "Ingrese un número válido.";
        },
        GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
        GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
        min2: (value) =>
          value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
        min5: (value) =>
          value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
        max10: (value) =>
          value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
        max25: (value) =>
          value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
        max30: (value) =>
          value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
        max45: (value) =>
          value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
        max50: (value) =>
          value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
        max100: (value) =>
          value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
        email: (value) => {
          const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
          return pattern.test(value) || "Ingrese un email válido.";
        },
      },

      search: "",
      searchPersonaValue: "",
      searchCargoValue: "",
      searchAreaValue: "",
      searchCodigoValue: "",
      searchLineaVenta: "",
      searchPersIncNombre: "",
      searchPersIncCargo: "",
      searchPersIncCenco: "",

      editCodigo: false,
      editCodigo2: true,

      editedIndexPer: false,

      editedIndexCuc: false,

      editedIndexLnv: false,
      editedIndexDir: -1,
      editedIndexIns: -1,

      id: "",
      id_linea_venta: "",

      id_parper: "",
      codigo: "",
      doc_identidad: "",
      id_persona: "",
      nombre_1: "",
      nombres_2: "",
      nombres_3: "",
      apellido_1: "",
      apellido_2: "",
      apellido_3: "",
      foto: "",
      fechaActual: "",
      fecha_inicio:
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 5) + "01",
      fecha_fin:
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 5) + "12",
      fechaAcstual: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      validaPersona: 0,
      validaLineaVenta: 0,
      validaPersona: 0,
      tipoCarga: "",
      validaNit: 0,
      modalFechaIni: false,
      modalFechaFin: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      codigoNit: "",
      descripcionNit: "",
      notasNit: "",
      primer_nombreNit: "",
      segundo_nombreNit: "",
      primer_apellidoNit: "",
      segundo_apellidoNit: "",
      direccionNit: "",
      correoNit: "",
      telefonoNit: "",
      celularNit: "",
      porcentaje: 0,

      adCodigo: "",
      errorMessagesPersona: "",
      errorMessagesPorc: "",
      errorMessagesLineaVenta: "",

      errorMessagesNit: "",
      errorMessagesUpload: "",

      nombreCompleto: "",
      emitido_en: "",
      tipo_doc: "",
      adic_segip: "",
      vence_doc: "",
      pension: "",
      dias_vacacion: "",
      aplica_afp: "S",
      es_jubilado: "",
      nua: "",
      id_pais: 30,
      id_pais_nac: 30,
      id_ciudad: 0,

      fecha_nac: "",
      fecha_ingreso: "",
      fecha_ingreso: "",
      fecha_ingreso_vac: "",
      fecha_ingreso_ant_vac: "",
      fecha_ingreso_bono_ant: "",
      fecha_salida: "",
      genero: "",
      estado_civil: "",
      tipo_sangre: "",
      pasaporte: "",
      permiso_conducir: "",
      forma_pago: "",
      vence_permiso: "",
      id_nit: "",
      cant_subsidio: "",
      fecha_subsidio_1: "",
      fecha_subsidio_2: "",
      fecha_subsidio_3: "",
      fecha_cupo: this.$formatoFecha(new Date()),
      subsidio: "",

      profesion: "",
      nivel_academico: "",
      motivo_retiro: "",
      telefono_1: "",
      telefono_2: "",
      telefono_3: "",
      contacto_emer: "",
      telefono_emer: "",
      direccion: "",
      viv_prop: "D",
      veh_prop: "D",
      dep_ini: "0",
      dep_prim: "0",
      dep_sec: "0",
      modo_sueldo: "MM",

      email_1: "",
      email_2: "",
      email_3: "",

      red_social_1: "",
      red_social_2: "",
      red_social_3: "",
      info_adicional: "",
      motivo: "",
      salario_ref: "",
      comision: "",
      nro_cuenta: "",
      nro_asegurado: "",
      aplica_seguro: "",
      tiene_discapacidad: "",
      tutor_discapacidad: "",
      id_banco: "",
      id_seguro: "",
      porcentajeLnv: 0,
      porcentajeInc: 0,
      talla_camisa: "",
      talla_pantalon: "",
      talla_zapato: "",
      tab: null,
      file: null,
      mostrarErrores: false,
      price: "",

      persona_cargo: "",
      id_cargo: "",
      id_cupo: "",
      id_grupo_nomina: "",
      id_area: "",
      id_subarea: "",
      id_persona_cargo: "",
      cargo: "",
      grupo: "",
      observaciones: "",
      email: "",
      telefono1: "",
      telefono2: "",

      zona: "",
      calle: "",
      numero: "",
      edificio: "",
      piso: "",

      area: "",
      referencia: "",

      mostrarInactivos: false,

      error: "",
      dialogActivar: false,
      dialogLineaVenta: false,
      dialogQR: false,
      estado: "",
    };
  },

  computed: {
    formTitle() {
      return (
        this.codigo +
        " - " +
        this.apellido_1 +
        " " +
        this.apellido_2 +
        " " +
        this.apellido_3 +
        ", " +
        this.nombre_1 +
        " " +
        this.nombres_2 +
        " " +
        this.nombres_3
      );
    },

    formPersona() {
      return {
        codigo: this.codigo,
        nombre_1: this.nombre_1,
        nombres_2: this.nombres_2,
        nombres_3: this.nombres_3,
        apellido_1: this.apellido_1,
        apellido_2: this.apellido_2,
        apellido_3: this.apellido_3,
        fecha_nac: this.fecha_nac,
        id_pais_nac: this.id_pais_nac,
        id_ciudad: this.id_ciudad,
        doc_identidad: this.doc_identidad,
        emitido_en: this.emitido_en,
        tipo_doc: this.tipo_doc,
        adic_segip: this.adic_segip,

        vence_doc: this.vence_doc,
        genero: this.genero,
        estado_civil: this.estado_civil,
        id_pais: this.id_pais,
        permiso_conducir: this.permiso_conducir,
        vence_permiso: this.vence_permiso,

        telefono_emer: this.telefono_emer,
        direccion: this.direccion,
        contacto_emer: this.contacto_emer,
        telefono_1: this.telefono_1,
        telefono_2: this.telefono_2,
        email_1: this.email_1,
        email_2: this.email_2,

        dep_ini: this.dep_ini,
        dep_prim: this.dep_prim,
        dep_sec: this.dep_sec,
        profesion: this.profesion,
        nivel_academico: this.nivel_academico,
        motivo_retiro: this.motivo_retiro,
        fecha_ingreso: this.fecha_ingreso,
        fecha_ingreso_vac: this.fecha_ingreso_vac,
        fecha_ingreso_ant_vac: this.fecha_ingreso_ant_vac,
        fecha_ingreso_bono_ant: this.fecha_ingreso_bono_ant,
        id_area: this.id_area,
        id_subarea: this.id_subarea,
        id_cargo: this.id_cargo,
        id_cupo: this.id_cupo,
        id_grupo_nomina: this.id_grupo_nomina,
        telefono_3: this.telefono_3,
        email_3: this.email_3,
        fecha_salida: this.fecha_salida,
        info_adicional: this.info_adicional,

        salario_ref: this.salario_ref,
        comision: this.comision,
        id_nit: this.id_nit,
        cant_subsidio: this.cant_subsidio,
        fecha_subsidio_1: this.fecha_subsidio_1,
        fecha_subsidio_2: this.fecha_subsidio_2,
        fecha_subsidio_3: this.fecha_subsidio_3,
        subsidio: this.subsidio,
        talla_camisa: this.talla_camisa,
        talla_pantalon: this.talla_pantalon,
        talla_zapato: this.talla_zapato,
        forma_pago: this.forma_pago,
        id_banco: this.id_banco,
        nro_cuenta: this.nro_cuenta,
        pension: this.pension,
        dias_vacacion: this.dias_vacacion,
        nua: this.nua,
        aplica_seguro: this.aplica_seguro,
        id_seguro: this.id_seguro,
        nro_asegurado: this.nro_asegurado,
        tutor_discapacidad: this.tutor_discapacidad,
        tiene_discapacidad: this.tiene_discapacidad,
      };
    },

    formNit() {
      return {
        codigoNit: this.codigoNit,
        descripcionNit: this.descripcionNit,
        notasNit: this.notasNit,
        primer_nombreNit: this.primer_nombreNit,
        segundo_nombreNit: this.segundo_nombreNit,
        primer_apellidoNit: this.primer_apellidoNit,
        segundo_apellidoNit: this.segundo_apellidoNit,
        direccionNit: this.direccionNit,
        correoNit: this.correoNit,
        telefonoNit: this.telefonoNit,
        celularNit: this.celularNit,
      };
    },

    formLineaVenta() {
      return {
        id_linea_venta: this.id_linea_venta,
        porcentaje: this.porcentaje,
      };
    },

    vacacionTomadaTotal() {
      const vacacionTomadaTotal = this.personasVacacion.reduce(
        (vac, d) => {
          vac.tomada += d.tomada;
          vac.ganada = d.ganada;
          vac.saldo = d.saldo;

          return vac;
        },
        {
          tomada: 0,
          ganada: 0,
          saldo: 0,
        }
      );
      vacacionTomadaTotal.tomada = this.$formatoNumero(
        vacacionTomadaTotal.tomada
      ); //para agregar decimales
      vacacionTomadaTotal.ganada = this.$formatoNumero(
        vacacionTomadaTotal.ganada
      ); //para agregar decimales
      vacacionTomadaTotal.saldo = this.$formatoNumero(
        vacacionTomadaTotal.saldo
      ); //para agregar decimales
      return vacacionTomadaTotal;
    },
  },

  watch: {
    dialogPersona(val) {
      val || this.closePersona();
    },

    dialogLineaVenta(val) {
      val || this.closeLineaVenta();
    },
    dialogFoto(val) {
      val || this.closeFoto();
    },

    dialogPersona(val) {
      val || this.closePersona();
    },
    dialogPersonaIncremento(val) {
      val || this.closeIncremento();
    },

    name() {
      this.errorMessagesPersona = "";
      this.errorMessagesLineaVenta = "";
      this.errorMessagesPorc = "";

      this.errorMessagesNit = "";
      this.errorMessagesUpload = "";
    },
  },

  created() {
    this.listarPersona();
    this.listarPersonaIncremento();
    this.selectPaises();
    this.selectCiudades();
    this.selectArea();
    this.selectBancos();
    this.selectSeguros();
    this.selectNits();
    this.selectLineaVenta();
    this.selectGrupo();
  },

  methods: {
    rowClick(item, row) {
      console.log("row clicked");
    },
    rowCtrlClicked(item, row) {
      console.log("row ctrl clicked");
    },
    clickEvent(event) {
      console.log("clicked");
      console.log("event", event);
    },

    archivoCambiado(e) {
      this.selectedFile = e;
      if (e != null) {
        this.foto = URL.createObjectURL(this.selectedFile);
      } else {
        this.foto = "";
      }
    },

    mostrarOcultarPersonas() {
      let me = this;
      me.mostrarInactivos = !me.mostrarInactivos;
      me.listarPersona();
    },

    listarPersona() {
      let me = this;

      axios
        .get("api/personas/ListarSubordinados/" + me.usuario)
        .then(function (response) {
          me.personas = response.data;
          console.log(me.personas);
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight + me.auxHeigth;
        })
        .catch(function (error) {
          console.log(error);
        });
      //me.mostrarInactivos = !me.mostrarInactivos;
    },
    listarPersonaVacacion() {
      let me = this;

      axios
        .get(
          "api/personas/ListarVacacionesPeriodoPersona/" +
            me.codigo +
            "/" +
            me.fecha_inicio +
            "/" +
            me.fecha_fin
        )
        .then(function (response) {
          me.personasVacacion = response.data;

          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight + me.auxHeigth;
        })
        .catch(function (error) {
          console.log(error);
        });
      //me.mostrarInactivos = !me.mostrarInactivos;
    },

    listarPersonaIncremento() {
      let me = this;

      axios
        .get("api/personas/listar/" + true)
        .then(function (response) {
          me.personasIncremento = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarBusqueda() {
      this.mostrarBusquedas = !this.mostrarBusquedas;
    },

    selectCargo() {
      let me = this;
      axios
        .get("api/cargos/filtrarSubarea/" + this.id_subarea)
        .then(function (response) {
          me.cargos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectCupo() {
      let me = this;
      axios
        .get("api/cupos/filtrarCargo/" + this.id_cargo + "/" + this.id)
        .then(function (response) {
          me.cupos =
            response.data === "" || response.data === "null"
              ? []
              : response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectSubarea() {
      let me = this;
      axios
        .get("api/subareas/Select/" + this.id_area)
        .then(function (response) {
          me.subareas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    closePersona() {
      this.dialogPersona = false;
      this.limpiarPersona();
    },
    closeIncremento() {
      this.dialogPersonaIncremento = false;
    },
    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },
    closePorcentaje() {
      this.dialogPorcentaje = false;
      this.porcentajeInc = 0;
    },
    closePersonaIncremento() {
      this.dialogPersonaIncremento = false;
    },
    closeLineaVenta() {
      this.dialogLineaVenta = false;
      this.limpiarLineaVenta();
    },

    closeNit() {
      this.dialogNit = false;
      this.limpiarNit();
    },

    closeQR() {
      this.dialogQR = false;
    },

    setFechaIni() {
      let me = this;

      //me.fecha_cierre=this.formatoFechaSpanish(me.fecha_cierre);
      me.modalFechaIni = false;
      me.listarPersonaVacacion();
    },
    setFechaFin() {
      let me = this;
      //me.fecha_cierre=this.formatoFechaSpanish(me.fecha_cierre);
      me.modalFechaFin = false;
      me.listarPersonaVacacion();
    },
    guardarSueldo(item) {
      let me = this;

      axios
        .put(
          "api/personas/ActualizarSalario/" +
            item.id +
            "/" +
            item.salario_ref +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.listarPersonaIncremento();
          me.$store.dispatch("setSnackbar", {
            text: "Salario actualizado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cancelarSueldo() {
      let me = this;
      me.$store.dispatch("setSnackbar", {
        text: "Acción cancelada.",
        color: "info",
      });
    },

    exportarExcel() {
      let me = this;
      try {
        json2excel({
          data: me.personas,
          name: "Personas",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error(e);
      }
    },

    guardarExcel() {
      let me = this;
      console.log("aqui");
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/log_cambios_personales/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            //me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    guardarExcelPersonas() {
      let me = this;
      console.log("persona");
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/personas/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listarPersona();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    sincronizarPersona() {
      let me = this;

      axios
        .put("api/personas/sincronizarPersona/" + me.usuario, {})
        .then(function (response) {
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
          me.listarPersona();
        })
        .catch(function (err) {
          me.mostrarErrores = true;
          me.$store.dispatch("setSnackbar", {
            text: err.response.data,
            color: "error",
          });
        });
    },
    sincronizarSalarios() {
      let me = this;

      axios
        .put("api/personas/sincronizarSalarios/" + me.usuario, {})
        .then(function (response) {
          me.$store.dispatch("setSnackbar", {
            text: response.data,
            color: "success",
          });
          me.listarPersona();
          me.listarPersonaIncremento();
          me.dialogSincronizarSueldos = false;
        })
        .catch(function (err) {
          me.mostrarErrores = true;
          me.$store.dispatch("setSnackbar", {
            text: err.response.data,
            color: "error",
          });
        });
    },

    modificarSalarios() {
      //codigo para guardar
      let me = this;

      axios
        .post("api/personas/ModificacíonSalarial", {
          porcentaje: me.porcentajeInc,
          persona: me.selectPersonasIncremento,
          usuario: me.usuario,
        })
        .then(function (response) {
          me.closePorcentaje();
          //me.listar();
          me.listarPersonaIncremento();
          me.$store.dispatch("setSnackbar", {
            text: " Salarios modificados exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    limpiarNit() {
      this.codigoNit = "";
      this.descripcionNit = "";
      this.notasNit = "";
      this.primer_nombreNit = "";
      this.segundo_nombreNit = "";
      this.primer_apellidoNit = "";
      this.segundo_apellidoNit = "";
      this.direccionNit = "";
      this.correoNit = "";
      this.telefonoNit = "";
      this.celularNit = "";
      this.validaMensajeNit = [];
    },

    selectPaises() {
      let me = this;
      var paisesArray = [];
      axios
        .get("api/paises/select")
        .then(function (response) {
          paisesArray = response.data;
          paisesArray.map(function (x) {
            me.paises.push({ text: x.descripcion, value: x.id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectArea() {
      let me = this;
      axios
        .get("api/areas/select")
        .then(function (response) {
          me.areas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectLineaVenta() {
      let me = this;
      axios
        .get("api/linea_ventas/select")
        .then(function (response) {
          me.lineaVentasList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectGrupo() {
      let me = this;
      axios
        .get("api/grupo_nominas/select")
        .then(function (response) {
          me.grupos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectCiudades() {
      let me = this;
      axios
        .get("api/ciudades/filtrarPais/" + this.id_pais_nac)
        .then(function (response) {
          me.ciudades = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectBancos() {
      let me = this;
      axios
        .get("api/bancos/select")
        .then(function (response) {
          me.bancos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectSeguros() {
      let me = this;
      axios
        .get("api/seguros/select")
        .then(function (response) {
          me.seguros = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectNits() {
      let me = this;
      axios
        .get("api/nits/select")
        .then(function (response) {
          me.nits = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editItemPersona(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.nombre_1 = item.nombre_1;
      this.nombres_2 = item.nombres_2 === null ? "" : item.nombres_2;
      this.nombres_3 = item.nombres_3 === null ? "" : item.nombres_3;

      this.apellido_1 = item.apellido_1;
      this.apellido_2 = item.apellido_2 === null ? "" : item.apellido_2;
      this.apellido_3 = item.apellido_3 === null ? "" : item.apellido_3;

      this.tipo_doc = item.tipo_doc;
      this.adic_segip = item.adic_segip;
      this.tipo_doc = item.tipo_doc === null ? "" : item.tipo_doc;
      this.vence_doc = this.$formatoFecha(item.vence_doc);
      this.adic_segip = item.adic_segip === null ? "" : item.adic_segip;
      this.pension = item.pension === null ? "" : item.pension;
      this.dias_vacacion =
        item.dias_vacacion === null ? "0" : item.dias_vacacion;

      this.aplica_afp = item.aplica_afp === null ? "S" : item.aplica_afp;
      this.es_jubilado = item.es_jubilado === null ? "S" : item.es_jubilado;
      this.nua = item.nua === null ? "" : item.nua;
      this.doc_identidad =
        item.doc_identidad === null ? "" : item.doc_identidad;
      this.emitido_en = item.emitido_en;
      this.fecha_nac = this.$formatoFecha(item.fecha_nac);
      this.fecha_ingreso = this.$formatoFecha(item.fecha_ingreso);
      this.fecha_ingreso_vac = this.$formatoFecha(item.fecha_ingreso_vac);
      this.fecha_ingreso_ant_vac = this.$formatoFecha(
        item.fecha_ingreso_ant_vac
      );
      this.fecha_ingreso_bono_ant = this.$formatoFecha(
        item.fecha_ingreso_bono_ant
      );
      this.fecha_salida = this.$formatoFecha(item.fecha_salida);
      this.id_pais = item.id_pais;
      this.id_pais_nac = item.id_pais_nac;
      this.id_ciudad = item.id_ciudad;
      this.genero = item.genero;
      this.estado_civil = item.estado_civil;
      this.tipo_sangre = item.tipo_sangre;

      this.pasaporte = item.pasaporte === null ? "" : item.pasaporte;
      this.permiso_conducir = item.permiso_conducir;
      this.forma_pago = item.forma_pago;
      this.vence_permiso = this.$formatoFecha(item.vence_permiso);

      this.id_nit = item.id_nit === null ? "" : item.id_nit;
      this.subsidio = item.subsidio === null ? "N" : item.subsidio;
      this.cant_subsidio =
        item.cant_subsidio === null ? "0" : item.cant_subsidio;
      this.fecha_subsidio_1 = this.$formatoFecha(item.fecha_subsidio_1);
      this.fecha_subsidio_2 = this.$formatoFecha(item.fecha_subsidio_2);
      this.fecha_subsidio_3 = this.$formatoFecha(item.fecha_subsidio_3);

      this.id_cargo = item.id_cargo === null ? "" : item.id_cargo;
      this.id_cupo = item.id_cupo === null ? "" : item.id_cupo;
      this.fecha_cupo =
        item.fecha_cupo === null
          ? this.$formatoFecha(new Date())
          : this.$formatoFecha(item.fecha_cupo);
      this.id_grupo_nomina =
        item.id_grupo_nomina === null ? "" : item.id_grupo_nomina;

      //this.rubro_empresa=item.rubro_empresa === null ? "":item.rubro_empresa;
      this.profesion = item.profesion === null ? "" : item.profesion;
      this.nivel_academico =
        item.nivel_academico === null ? "" : item.nivel_academico;
      this.motivo_retiro =
        item.motivo_retiro === null ? "" : item.motivo_retiro;
      this.nro_cuenta = item.nro_cuenta === null ? "" : item.nro_cuenta;
      this.nro_asegurado =
        item.nro_asegurado === null ? "" : item.nro_asegurado;
      this.aplica_seguro =
        item.aplica_seguro === null ? "" : item.aplica_seguro;
      this.tiene_discapacidad =
        item.tiene_discapacidad === null ? "" : item.tiene_discapacidad;
      this.tutor_discapacidad =
        item.tutor_discapacidad === null ? "" : item.tutor_discapacidad;
      this.id_banco = item.id_banco === null ? "" : item.id_banco;
      this.id_area = item.id_area === null ? "" : item.id_area;
      this.id_subarea = item.id_subarea === null ? "" : item.id_subarea;
      this.id_seguro = item.id_seguro === null ? "" : item.id_seguro;
      this.talla_camisa = item.talla_camisa === null ? "" : item.talla_camisa;
      this.talla_pantalon =
        item.talla_pantalon === null ? "" : item.talla_pantalon;
      this.talla_zapato = item.talla_zapato === null ? "" : item.talla_zapato;
      //this.tipo_actividad=item.tipo_actividad === null ? "":item.tipo_actividad;
      this.info_adicional =
        item.info_adicional === null ? "" : item.info_adicional;
      this.motivo = item.motivo === null ? "" : item.motivo;
      this.salario_ref = this.$esNulo(item.salario_ref)
        ? this.$formatoNumero(0)
        : this.$formatoNumero(item.salario_ref);
      this.comision = this.$esNulo(item.comision)
        ? this.$formatoNumero(0)
        : this.$formatoNumero(item.comision);

      this.email_1 = item.email_1 === null ? "" : item.email_1;
      this.email_2 = item.email_2 === null ? "" : item.email_2;
      this.email_3 = item.email_3 === null ? "" : item.email_3;
      this.telefono_1 = item.telefono_1 === null ? "" : item.telefono_1;
      this.telefono_2 = item.telefono_2 === null ? "" : item.telefono_2;
      this.telefono_3 = item.telefono_3 === null ? "" : item.telefono_3;
      this.contacto_emer =
        item.contacto_emer === null ? "" : item.contacto_emer;
      this.telefono_emer =
        item.telefono_emer === null ? "" : item.telefono_emer;
      this.direccion = item.direccion === null ? "" : item.direccion;
      this.viv_prop = item.viv_prop === null ? "D" : item.viv_prop;
      this.modo_sueldo = item.modo_sueldo === null ? "MM" : item.modo_sueldo;
      this.veh_prop = item.veh_prop === null ? "D" : item.veh_prop;
      this.dep_ini =
        item.dep_ini === null ? "0" : item.dep_ini === 0 ? "0" : item.dep_ini;
      this.dep_prim =
        item.dep_prim === null
          ? "0"
          : item.dep_prim === 0
          ? "0"
          : item.dep_prim;
      this.dep_sec =
        item.dep_sec === null ? "0" : item.dep_sec === 0 ? "0" : item.dep_sec;
      this.red_social_1 = item.red_social_1 === null ? "" : item.red_social_1;
      this.red_social_2 = item.red_social_2 === null ? "" : item.red_social_2;
      this.red_social_3 = item.red_social_3 === null ? "" : item.red_social_3;

      this.foto = item.foto;
      this.editedIndexPer = true;
      this.dialogPersona = true;
      this.estado = item.estado;

      this.listarPersonaVacacion();

      this.editCodigo2 = false;
      this.editCodigo = false;
    },

    editItemLineaVenta(item) {
      this.id_linea_venta = item.id_linea_venta;
      this.porcentaje = item.porcentaje;
      this.editedIndexLnv = true;
      this.dialogLineaVenta = true;
    },

    closePersona() {
      this.dialogPersona = false;
      this.limpiarPersona();
    },

    closeFoto() {
      this.dialogFoto = false;
    },

    limpiarPersona() {
      this.id = 0;
      this.codigo = "";
      this.nombre_1 = "";
      this.nombres_2 = "";
      this.nombres_3 = "";
      this.apellido_1 = "";
      this.apellido_2 = "";
      this.apellido_3 = "";

      this.tipo_doc = "";
      this.adic_segip = "";
      this.vence_doc = "";
      this.pension = "";
      this.dias_vacacion = "";
      this.es_jubilado = "";
      this.nua = "";
      this.doc_identidad = "";
      this.emitido_en = "";
      this.fecha_nac = "";
      this.fecha_salida = "";
      this.fecha_ingreso = "";
      this.fecha_ingreso_bono_ant = "";
      this.fecha_ingreso_ant_vac = "";
      this.fecha_ingreso_vac = "";
      this.id_pais = "30";
      this.id_pais_nac = "30";
      this.id_ciudad = "30";
      this.dep_ini = "0";
      this.dep_sec = "0";
      this.dep_prim = "0";
      this.genero = "";
      this.direccion = "";
      this.id_estado_civil = "";
      this.tipo_sangre = "";
      this.pasaporte = "";
      this.permiso_conducir = "";
      this.forma_pago = "";
      this.vence_permiso = "";
      this.id_nit = "";
      (this.cant_subsidio = "0"),
        (this.fecha_subsidio_1 = ""),
        (this.fecha_subsidio_2 = ""),
        (this.fecha_subsidio_3 = ""),
        (this.subsidio = "N"),
        (this.id_cargo = "");
      this.id_cupo = [""];
      this.cupos = [];
      this.id_grupo_nomina = "";
      this.profesion = "";
      this.nivel_academico = "";
      this.motivo_retiro = "";
      this.id_banco = "";
      this.id_departamento = "";
      this.id_seguro = "";
      this.id_horario = "";
      this.id_plaza = "";
      this.id_ubicacion = "";
      this.id_estado_empleado = "";
      this.id_nomina = "";

      this.talla_camisa = "";
      this.talla_pantalon = "";
      this.talla_zapato = "";
      this.id_tipo_cuenta = "";
      this.nro_cuenta = "";
      this.nro_asegurado = "";
      this.aplica_seguro = "";
      this.tiene_discapacidad = "";
      this.tutor_discapacidad = "";
      this.info_adicional = "";
      this.motivo = "";
      this.salario_ref = "";
      this.comision = "";

      this.email_1 = "";
      this.email_2 = "";
      this.email_3 = "";
      this.telefono_1 = "";
      this.telefono_2 = "";
      this.telefono_3 = "";
      this.telefono_emer = "";
      this.contacto_emer = "";

      this.red_social_1 = "";
      this.red_social_2 = "";
      this.red_social_3 = "";
      this.foto = "/uploads/a.png";
      this.editedIndexPer = false;

      this.editCodigo2 = true;
      this.tab = 0;
    },

    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    limpiarLineaVenta(item) {
      this.id_linea_venta = "";
      this.id_persona = "";
      this.porcentaje = "";
      this.editedIndexLnv = false;
    },

    limpiarclosePersona() {
      this.id = 0;
      this.codigo = "";
      this.nombre_1 = "";
      this.nombres_2 = "";
      this.nombres_3 = "";
      this.apellido_1 = "";
      this.apellido_2 = "";
      this.apellido_3 = "";

      this.tipo_doc = "";
      this.adic_segip = "";
      this.vence_doc = "";
      this.pension = "";
      this.dias_vacacion = "";

      this.es_jubilado = "";
      this.nua = "";
      this.doc_identidad = "";
      this.emitido_en = "";
      this.fecha_nac = "";
      this.fecha_salida = "";
      this.fecha_ingreso = "";
      this.fecha_ingreso_bono_ant = "";
      this.fecha_ingreso_ant_vac = "";
      this.fecha_ingreso_vac = "";
      this.id_pais = "30";
      this.id_pais_nac = "30";
      this.id_ciudad = "30";
      this.genero = "";
      this.estado_civil = "";
      this.tipo_sangre = "";
      this.pasaporte = "";
      this.permiso_conducir = "";
      this.forma_pago = "";
      this.vence_permiso = "";
      this.id_nit = "";
      (this.cant_subsidio = "0"),
        (this.fecha_subsidio_1 = ""),
        (this.fecha_subsidio_2 = ""),
        (this.fecha_subsidio_3 = ""),
        (this.subsidio = "N"),
        (this.id_cargo = "");
      this.id_cupo = "";
      this.id_grupo_nomina = "";
      this.profesion = "";
      this.nivel_academico = "";
      this.motivo_retiro = "";
      this.id_banco = "";
      this.id_area = "";
      this.id_subarea = "";
      this.id_seguro = "";

      this.talla_camisa = "";
      this.talla_pantalon = "";
      this.talla_zapato = "";
      this.nro_cuenta = "";
      this.nro_asegurado = "";
      this.aplica_seguro = "";
      this.tiene_discapacidad = "";
      this.tutor_discapacidad = "";
      this.info_adicional = "";
      this.motivo = "";
      this.salario_ref = "";
      this.comision = "";

      this.email_1 = "";
      this.email_2 = "";
      this.email_3 = "";
      this.telefono_1 = "";
      this.telefono_2 = "";
      this.telefono_3 = "";
      this.telefono_emer = "";
      this.direccion = "";
      this.contacto_emer = "";

      this.dep_ini = "";
      this.dep_prim = "";
      this.dep_sec = "";

      this.red_social_1 = "";
      this.red_social_2 = "";
      this.red_social_3 = "";
      this.foto = "/uploads/loog_clwever.png";
      this.editedIndexPer = false;

      this.editCodigo2 = true;
      this.tab = 0;
    },

    deleteItemLineaVenta(item) {
      this.id_linea_venta = item.id_linea_venta;
      this.dialogBorrarLineaVenta = true;
    },

    guardarLineaVenta() {
      if (this.validarLineaVenta() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.editedIndexLnv) {
        let me = this;
        axios
          .put("api/persona_lineas/actualizar", {
            id_persona: me.id,
            id_linea_venta: me.id_linea_venta,
            porcentaje: me.porcentaje,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeLineaVenta();
            me.listarLineaVenta();
            me.limpiarLineaVenta();
            me.$store.dispatch("setSnackbar", {
              text: "Registro actualizado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: error, color: "error" });
          });
      } else {
        let me = this;
        axios
          .post("api/persona_lineas/crear", {
            id_persona: me.id,
            id_linea_venta: me.id_linea_venta,
            porcentaje: me.porcentaje,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeLineaVenta();
            me.listarLineaVenta();
            me.limpiarLineaVenta();
            me.$store.dispatch("setSnackbar", {
              text: "Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    listarLineaVenta() {
      let me = this;
      axios
        .get("api/persona_lineas/listarLineaPersona/" + this.id)
        .then(function (response) {
          me.mostrarPorcentaje();
          me.LineaVentas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarPorcentaje() {
      let me = this;
      axios
        .get("api/persona_lineas/mostarPorcentaje/" + this.id)
        .then(function (response) {
          me.porcentajeLnv = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    eliminarLineaVenta() {
      let me = this;

      axios
        .delete(
          "api/persona_lineas/EliminarPersonaLinea/" +
            me.id +
            "/" +
            me.id_linea_venta,
          {}
        )
        .then(function (response) {
          me.listarLineaVenta();
          me.$store.dispatch("setSnackbar", {
            text: "Linea de Venta eliminada exitosamente.",
            color: "success",
          });
          me.dialogBorrarLineaVenta = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    guardarPersona() {
      if (this.validarPersona() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      this.salario_ref = this.$quitarFormatoNumero(this.salario_ref);
      this.comision = this.$quitarFormatoNumero(this.comision);

      if (isNaN(this.salario_ref) || isNaN(this.comision)) {
        this.$store.dispatch("setSnackbar", {
          text: "Ingrese números válidos.",
          color: "error",
        });
        return;
      }
      if (this.fecha_nac == null) {
        this.fecha_nac = "";
      }
      if (this.fecha_ingreso == null) {
        this.fecha_ingreso = "";
      }
      if (this.fecha_ingreso_vac == null) {
        this.fecha_ingreso_vac = "";
      }
      if (this.fecha_ingreso_ant_vac == null) {
        this.fecha_ingreso_ant_vac = "";
      }
      if (this.fecha_ingreso_bono_ant == null) {
        this.fecha_ingreso_bono_ant = "";
      }
      if (this.fecha_salida == null) {
        this.fecha_salida = "";
      }
      if (this.vence_doc == null) {
        this.vence_doc = "";
      }
      if (this.vence_permiso == null) {
        this.vence_permiso = "";
      }
      if (this.fecha_subsidio_1 == null) {
        this.fecha_subsidio_1 = "";
      }
      if (this.fecha_subsidio_2 == null) {
        this.fecha_subsidio_2 = "";
      }
      if (this.fecha_subsidio_3 == null) {
        this.fecha_subsidio_3 = "";
      }
      if (this.$esNulo(this.cant_subsidio)) {
        this.cant_subsidio = "0";
      }

      if (this.editedIndexPer) {
        let me = this;
        const formData = new FormData();
        formData.append("id", this.id);
        formData.append("codigo", this.codigo);
        formData.append("doc_identidad", this.doc_identidad);
        formData.append("tipo_doc", this.tipo_doc);
        formData.append("vence_doc", this.vence_doc);
        formData.append("adic_segip", this.adic_segip);
        formData.append("pension", this.pension);
        formData.append("afp", this.pension);
        formData.append("aplica_afp", this.aplica_afp);
        formData.append("es_jubilado", this.es_jubilado);
        formData.append("nua", this.nua);
        formData.append("emitido_en", this.emitido_en);
        formData.append("apellido_1", this.apellido_1);
        formData.append("apellido_2", this.apellido_2);
        formData.append("apellido_3", this.apellido_3);
        formData.append("nombre_1", this.nombre_1);
        formData.append("nombres_2", this.nombres_2);
        formData.append("nombres_3", this.nombres_3);
        formData.append("fecha_nac", this.fecha_nac);
        formData.append("fecha_ingreso", this.fecha_ingreso);
        formData.append("fecha_ingreso_bono_ant", this.fecha_ingreso_bono_ant);
        formData.append("fecha_ingreso_ant_vac", this.fecha_ingreso_ant_vac);
        formData.append("fecha_ingreso_vac", this.fecha_ingreso_vac);
        formData.append("fecha_salida", this.fecha_salida);
        formData.append("id_pais", this.id_pais);
        formData.append("id_pais_nac", this.id_pais_nac);
        formData.append("id_ciudad", this.id_ciudad);
        formData.append("genero", this.genero);
        formData.append("estado_civil", this.estado_civil);
        formData.append("tipo_sangre", "O+");
        formData.append("pasaporte", this.pasaporte);
        formData.append("permiso_conducir", this.permiso_conducir);
        formData.append("forma_pago", this.forma_pago);
        formData.append("vence_permiso", this.vence_permiso);
        formData.append("id_nit", this.id_nit);

        formData.append("fecha_subsidio_1", this.fecha_subsidio_1);
        formData.append("fecha_subsidio_2", this.fecha_subsidio_2);
        formData.append("fecha_subsidio_3", this.fecha_subsidio_3);
        formData.append("subsidio", this.subsidio);
        formData.append("cant_subsidio", this.cant_subsidio);

        formData.append("id_cargo", this.id_cargo);
        formData.append("id_cupo", this.id_cupo);
        formData.append("fecha_cupo", this.fecha_cupo);
        formData.append("id_grupo_nomina", this.id_grupo_nomina);
        formData.append("telefono_1", this.telefono_1);
        formData.append("telefono_2", this.telefono_2);
        formData.append("telefono_3", this.telefono_3);
        formData.append("contacto_emer", this.contacto_emer);
        formData.append("viv_prop", this.viv_prop);
        formData.append("veh_prop", this.veh_prop);
        formData.append("dep_ini", this.dep_ini);
        formData.append("dep_prim", this.dep_prim);
        formData.append("dep_sec", this.dep_sec);
        formData.append("telefono_emer", this.telefono_emer);
        formData.append("direccion", this.direccion);
        formData.append("email_1", this.email_1);
        formData.append("email_2", this.email_2);
        formData.append("email_3", this.email_3);
        formData.append("red_social_1", this.red_social_1);
        formData.append("red_social_2", this.red_social_2);
        formData.append("red_social_3", this.red_social_3);
        formData.append("profesion", this.profesion);
        formData.append("nivel_academico", this.nivel_academico);
        formData.append("motivo_retiro", this.motivo_retiro);
        formData.append("nro_cuenta", this.nro_cuenta);
        formData.append("nro_asegurado", this.nro_asegurado);
        formData.append("aplica_seguro", this.aplica_seguro);
        formData.append("tiene_discapacidad", this.tiene_discapacidad);
        formData.append("tutor_discapacidad", this.tutor_discapacidad);
        formData.append("id_banco", this.id_banco);
        formData.append("id_area", this.id_area);
        formData.append("id_seguro", this.id_seguro);
        formData.append("talla_camisa", this.talla_camisa);
        formData.append("talla_pantalon", this.talla_pantalon);
        formData.append("talla_zapato", this.talla_zapato);
        formData.append("info_adicional", this.info_adicional);
        formData.append("motivo", this.motivo);
        formData.append("salario_ref", this.salario_ref);
        formData.append("comision", this.comision);
        formData.append("usuario", this.usuario);

        if (this.selectedFile != null) {
          formData.append(this.selectedFile.name, this.selectedFile);
        } else {
          formData.append(null, null);
        }

        axios
          .put("api/personas/actualizar", formData)
          .then(function (response) {
            me.closePersona();
            me.listarPersona();
            me.limpiarPersona();
            me.$store.dispatch("setSnackbar", {
              text: "Registro actualizado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        let me = this;
        const formData = new FormData();
        formData.append("codigo", this.codigo);
        formData.append("doc_identidad", this.doc_identidad);
        formData.append("tipo_doc", this.tipo_doc);
        formData.append("adic_segip", this.adic_segip);
        formData.append("vence_doc", this.vence_doc);
        formData.append("pension", this.pension);
        formData.append("afp", this.pension);
        formData.append("aplica_afp", this.aplica_afp);
        formData.append("es_jubilado", this.es_jubilado);
        formData.append("nua", this.nua);
        formData.append("emitido_en", this.emitido_en);
        formData.append("apellido_1", this.apellido_1);
        formData.append("apellido_2", this.apellido_2);
        formData.append("apellido_3", this.apellido_3);
        formData.append("nombre_1", this.nombre_1);
        formData.append("nombres_2", this.nombres_2);
        formData.append("nombres_3", this.nombres_3);
        formData.append("fecha_nac", this.fecha_nac);
        formData.append("fecha_ingreso", this.fecha_ingreso);
        formData.append("fecha_ingreso_bono_ant", this.fecha_ingreso_bono_ant);
        formData.append("fecha_ingreso_ant_vac", this.fecha_ingreso_ant_vac);
        formData.append("fecha_ingreso_vac", this.fecha_ingreso_vac);
        formData.append("fecha_salida", this.fecha_salida);
        formData.append("id_pais", this.id_pais);
        formData.append("id_pais_nac", this.id_pais_nac);
        formData.append("id_ciudad", this.id_ciudad);
        formData.append("genero", this.genero);
        formData.append("estado_civil", this.estado_civil);
        formData.append("tipo_sangre", "O+");
        formData.append("pasaporte", this.pasaporte);
        formData.append("permiso_conducir", this.permiso_conducir);
        formData.append("forma_pago", this.forma_pago);
        formData.append("vence_permiso", this.vence_permiso);
        formData.append("id_nit", this.id_nit);
        formData.append("cant_subsidio", this.cant_subsidio);
        formData.append("fecha_subsidio_1", this.fecha_subsidio_1);
        formData.append("fecha_subsidio_2", this.fecha_subsidio_2);
        formData.append("fecha_subsidio_3", this.fecha_subsidio_3);
        formData.append("subsidio", this.subsidio);
        formData.append("id_cargo", this.id_cargo);
        formData.append("id_cupo", this.id_cupo);
        formData.append("fecha_cupo", this.fecha_cupo);
        formData.append("id_grupo_nomina", this.id_grupo_nomina);
        formData.append("telefono_1", this.telefono_1);
        formData.append("telefono_2", this.telefono_2);
        formData.append("telefono_3", this.telefono_3);
        formData.append("telefono_emer", this.telefono_emer);
        formData.append("direccion", this.direccion);
        formData.append("contacto_emer", this.contacto_emer);
        formData.append("viv_prop", this.viv_prop);
        formData.append("veh_prop", this.veh_prop);
        formData.append("dep_ini", this.dep_ini);
        formData.append("dep_prim", this.dep_prim);
        formData.append("dep_sec", this.dep_sec);
        formData.append("email_1", this.email_1);
        formData.append("email_2", this.email_2);
        formData.append("email_3", this.email_3);
        formData.append("red_social_1", this.red_social_1);
        formData.append("red_social_2", this.red_social_2);
        formData.append("red_social_3", this.red_social_3);
        formData.append("profesion", this.profesion);
        formData.append("nivel_academico", this.nivel_academico);
        formData.append("motivo_retiro", this.motivo_retiro);
        formData.append("nro_cuenta", this.nro_cuenta);
        formData.append("nro_asegurado", this.nro_asegurado);
        formData.append("aplica_seguro", this.aplica_seguro);
        formData.append("tiene_discapacidad", this.tiene_discapacidad);
        formData.append("tutor_discapacidad", this.tutor_discapacidad);
        formData.append("id_banco", this.id_banco);
        formData.append("id_area", this.id_area);
        formData.append("id_seguro", this.id_seguro);
        formData.append("talla_camisa", this.talla_camisa);
        formData.append("talla_pantalon", this.talla_pantalon);
        formData.append("talla_zapato", this.talla_zapato);
        formData.append("info_adicional", this.info_adicional);
        formData.append("motivo", this.motivo);
        formData.append("salario_ref", this.salario_ref);
        formData.append("comision", this.comision);
        formData.append("usuario", this.usuario);

        if (this.selectedFile != null) {
          formData.append(this.selectedFile.name, this.selectedFile);
        } else {
          formData.append(null, null);
        }

        axios
          .post("api/personas/crear", formData)
          .then(function (response) {
            me.id = response.data;
            me.editedIndexPer = true;
            me.listarPersona();
            me.closePersona();
            me.$store.dispatch("setSnackbar", {
              text: "Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    guardarNit() {
      if (this.validarNit() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      let me = this;
      axios
        .post("api/nit/crear", {
          codigo: me.codigoNit,
          descripcion: me.descripcionNit,
          notas: me.notasNit,
          primer_nombre: me.primer_nombreNit,
          segundo_nombre: me.segundo_nombreNit,
          primer_apellido: me.primer_apellidoNit,
          segundo_apellido: me.segundo_apellidoNit,
          direccion: me.direccionNit,
          correo: me.correoNit,
          telefono: me.telefonoNit,
          celular: me.celularNit,
        })
        .then(function (response) {
          me.closeNit();
          me.limpiarNit();
          me.selectNits();
          me.$store.dispatch("setSnackbar", {
            text: "Nit creado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    addItem() {
      this.editCodigo = true;
      this.dialogPersona = true;
    },

    mostrarCarga(tipo) {
      this.dialogUpload = true;
      this.tipoCarga = tipo;
    },
    mostrarPorcentajeInc() {
      if (this.selectPersonasIncremento.length == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos una persona.",
          color: "error",
        });
        return;
      }
      this.dialogPorcentaje = true;
    },
    mostrarPersonaIncremento() {
      this.dialogPersonaIncremento = true;
    },

    activarDialogPersona() {
      this.dialogPersona = true;
    },

    activarDialogNit() {
      this.dialogNit = true;
    },

    activarDialogQR() {
      this.dialogQR = true;
    },

    mostrarMensajeLineaVenta() {
      this.dialogQR = true;
    },

    validarPersona() {
      this.validaPersona = 0;
      var elemento = "";
      var v = 0;
      var i = 0;
      var e = 0;

      Object.keys(this.formPersona).forEach((f) => {
        console.log(f);
        this.$refs[f].validate(true);
        e += 1;
        i++;
        if (this.$refs[f].validate(true)) {
          this.validaPersona += 0;
        } else {
          if (v == 0) {
            v = i;
            elemento = f;
          }
          this.validaPersona += 1;
          return;
        }
      });
      /*con este fragmento de codigo es posible direccionar el foco entre pestañas cuando se presentan errores de formulario
            if (v>0){
                this.tab=0;
                this.$refs[elemento].focus();
                if (v>33){
                    this.tab=1;
                    this.$refs[elemento].focus();
                    if (v>16){
                        this.tab=2;
                        this.$refs[elemento].focus();
                    }
                } 
            }
            */
      return this.validaPersona;
    },

    validarNit() {
      this.validaNit = 0;
      var i = 0;
      Object.keys(this.formNit).forEach((f) => {
        i += 1;

        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.validaNit += 0;
        } else {
          this.validaNit += 1;
        }
      });
      return this.valida;
    },

    validarLineaVenta() {
      this.validaLineaVenta = 0;
      var elemento = "";
      var v = 0;
      var i = 0;
      Object.keys(this.formLineaVenta).forEach((f) => {
        this.$refs[f].validate(true);
        i++;
        if (this.$refs[f].validate(true)) {
          this.validaLineaVenta += 0;
        } else {
          if (v == 0) {
            v = i;
            elemento = f;
          }
          this.validaLineaVenta += 1;
        }
      });
      return this.validaLineaVenta;
    },

    mostrarNombre() {
      this.nombreCompleto =
        this.nombre_1 +
        " " +
        this.nombres_2 +
        " " +
        this.nombres_3 +
        " " +
        this.apellido_1 +
        " " +
        this.apellido_2 +
        " " +
        this.apellido_3;
    },

    mostrarCodigo() {
      if (this.editedIndexPer == false) {
        this.codigo = this.doc_identidad;
      }
    },

    activarDialog(item) {
      this.id = item.id;
      this.estado = item.estado;
      this.dialogActivar = true;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/personas/activar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.dialogActivar = false;
          me.listarPersona();
          me.$store.dispatch("setSnackbar", {
            text: "Persona activada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/personas/desactivar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.dialogActivar = false;
          me.listarPersona();
          me.$store.dispatch("setSnackbar", {
            text: "Persona desactivada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    redondear(numero, decimales) {
      let number = numero;
      let arreglo = 10 ** decimales;
      let total = Math.round(arreglo * number) / arreglo;

      return total;
    },

    filtroArea(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchAreaValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchAreaValue.toLowerCase());
    },
    filtroCargo(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCargoValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCargoValue.toLowerCase());
    },

    filtroCodigo(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCodigoValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCodigoValue.toLowerCase());
    },

    filtroIncCargo(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchPersIncCargo) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchPersIncCargo.toLowerCase());
    },

    filtroIncCenco(value) {
      // If this filter has no value we just skip the entire filter.

      if (!this.searchPersIncCenco) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      value = value == null ? "" : value;
      return value.includes(
        this.searchPersIncCenco == null ? "" : this.searchPersIncCenco
      );
    },

    filtroIncNombre(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchPersIncNombre) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchPersIncNombre.toLowerCase());
    },
  },
};
</script>
